


















































































































































import dayjs from 'dayjs';

import {getReceipts, exportReceipt, getYears, getAllTransctionsInfo, getInstitutions, getTransactionInfoByInstitution} from '@/api/receipts'
import router from '@/router';

import { Loading } from 'element-ui'
export default  {
  //模型数据
  data() {
    return {
      loading: false,

      name: '', // 咨询师姓名，对应上面的查询输入框
      year: '', // 年份
      institution: null,
      yearOptions: [],
      institutionOptions: [],
      transYear: '',
      transInstitution: '',
      transClientleNumber: 0,// 成交总人数
      transMoneyNumber: 0,// 成交总金额
      returnMoneyNumber: 0, // 回款总金额
      avergeMoneyNumber: 0, // 平均单价

      page: 1, //页码
      pageSize: 10, //每页记录数
      total: 0, //总记录数
      records: [], //当前页要展示的数据集合
      multipleSelection: '',
      // orderNumber: 0 //客单数
      selectedReceiptId: '', // 选中收据id
      selectedStuName: '',

      dialogVisible: false, // 控制弹出框显示
      form: {
        template: 0, // 选择的模板
      },

    }
  },
  created() {

    this.getYearOptions()
    this.getInstitutionOptions()
    this.setCurrentYear()
    this.pageQuery()


  },
  methods: {
    // 格式化金额
    formatCurrency(row, column, cellValue) {
      return cellValue ? parseFloat(String(cellValue)).toLocaleString() : "0";
    },
    setCurrentYear(){
      let month = new Date().getMonth()
      if(month<9)  this.year = new Date().getFullYear()
      else this.year = new Date().getFullYear() + 1
    },
    getYearOptions(){
      getYears().then( res => {
        if(res.data.code === 1){
          this.yearOptions = res.data.data
        }else{
          this.$message.warning("年份加载失败，请刷新页面重试")
        }

      })
    },
    getInstitutionOptions(){
      getInstitutions().then(res => {
        if(res.data.code === 1){
          this.institutionOptions = res.data.data
        }else{
          this.$message.warning("机构加载失败，请刷新页面重试")
        }
      })
    },

    getTransInfo(){
      const params = {
        // consultantName: this.name,
        institution: this.institution,
        year: this.year
      }
      getTransactionInfoByInstitution(params).then(res=>{
        if(res.data.code === 1){
          this.transYear = this.year + '年'
          this.transInstitution = this.institution === null ? '所有机构' : this.institution
          this.transClientleNumber = res.data.data.transClientleNumber
          this.transMoneyNumber = res.data.data.transMoneyNumber
          this.returnMoneyNumber = res.data.data.returnMoneyNumber
          this.avergeMoneyNumber = res.data.data.avergeMoneyNumber
          // alert(this.transClientleNumber)
        }else {
          this.$message.error("交易概览信息加载失败！")
        }
      })
    },

    formatDate(row, column, cellValue) {
      return dayjs(cellValue).format('YYYY-MM-DD');
    },



    //分页查询
    pageQuery() {

      this.loading = true
      //准备请求参数
      const params = {
        consultantName: this.name,
        year: this.year,
        page: this.page,
        pageSize: this.pageSize,
        institution: this.institution
      }
      //发送Ajax请求，访问后端服务，获取分页数据
      getAllTransctionsInfo(params).then(res => {
        if(res.data.code === 1) {
          this.total = res.data.data.total
          this.records = res.data.data.records
          this.getTransInfo()
          this.$message.success("数据获取成功！")
        }
      }).catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
      this.loading = false

    },
    //pageSize发生变化时触发
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageQuery()
    },
    //page发生变化时触发
    handleCurrentChange(page) {
      this.page = page
      this.pageQuery()
    },
    showDetail(consultantId: number){
      this.$router.push("receipts/consultantReceipt?consultantId="+consultantId+"&year="+this.year)
    },

// -----------------------------------------------
    openDialog(row) {
      this.selectedReceiptId = row.id
      this.selectedStuName = row.stuName
      this.dialogVisible = true; // 打开弹出框
    },
    confirm() {
      if (this.form.template==null) {
        this.$message.error("请选择模板！");
        return;
      }
      this.$message.success(`您选择了模板：${this.templates[this.form.template].label}`);
      this.exportPDF(this.selectedReceiptId, this.form.template, this.selectedStuName)
      this.dialogVisible = false; // 关闭弹出框
    },
    resetForm() {
      this.form.template = 0; // 重置表单
    },


  }
}
